import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { findById } from './data/records';

const LegacyRedirect = ({ target }) => {
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const record = findById(id);
        const dest = record
            ? (target === 'view' ? `/project/${record.slug}/view` : `/project/${record.slug}`)
            : '/project';
        navigate(dest, { replace: true });
    }, [id, target, navigate]);

    return null;
};

export default LegacyRedirect;
